<div *ngIf="!model">
  RECUPERANDO CAMPAÑA...
</div>
<div *ngIf="model">
  <div class="row">
    <div class="col-md-12" [innerHtml]="htmlPrint">
    </div>
  </div>
</div>
